import React from 'react';
import clsx from 'clsx';
import { Download } from 'lucide-react';

const ExportButton = ({
  onClick,
  children = 'Export',
  disabled = false,
  className = '',
  type = 'button',
  title,
  size = 'md',
}) => (
  <button
    type={type}
    onClick={onClick}
    disabled={disabled}
    title={title}
    className={clsx(
      'inline-flex items-center gap-2 rounded-lg border border-slate-200 bg-slate-100 font-semibold text-slate-900 shadow-sm transition hover:bg-slate-200 disabled:cursor-not-allowed disabled:opacity-60',
      size === 'sm' ? 'px-4 py-2 text-xs' : 'px-5 py-2.5 text-sm',
      className
    )}
  >
    <Download className="h-4 w-4" />
    {children}
  </button>
);

export default ExportButton;
